"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-float"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var Variant = /*#__PURE__*/function () {
  function Variant(json) {
    (0, _classCallCheck2["default"])(this, Variant);
    this.agg = false;
    this.c1 = null;
    this.c2 = null;
    this.classe = null;
    this.cle = null;
    this.cod = null;
    this.codbase = null;
    this.data = null;
    this.des = null;
    this.desl = null;
    this.destrad = null;
    this.div = false;
    this.fd = false;
    this.id = null;
    this.idpadre = null;
    this.img = null;
    this.imgColor = null;
    this.layer = null;
    this.layid = null;
    this.obbligate = false;
    this.tipo = null;
    this.value = null;
    this.valuedes = null;
    this.visible = false;
    this.aggName = null;
    this.agg = json.agg;
    this.c1 = json.c1;
    this.c2 = json.c2;
    this.classe = json.classe;
    this.cle = json.cle;
    this.cod = json.cod;
    this.codbase = json.codbase;
    this.data = json.data || null;
    this.des = json.des;
    this.desl = json.desl;
    this.destrad = json.destrad;
    this.div = json.div;
    this.fd = json.fd;
    this.id = json.id;
    this.idpadre = json.idpadre;
    this.img = json.img || null;
    this.imgColor = json.imgColor || null;
    this.layer = json.layer;
    this.layid = json.layid;
    this.obbligate = json.obbligate;
    this.tipo = json.tipo;
    this.valuedes = json.valuedes;
    this.visible = json.visible;
    this.value = json.value;
    this.aggName = json.aggName;
    this.checkFields(json);
  }
  (0, _createClass2["default"])(Variant, [{
    key: "checkFields",
    value: function checkFields(json) {
      var _context,
        _this = this;
      (0, _map["default"])(_context = (0, _keys["default"])(json)).call(_context, function (key) {
        if (!_this.hasOwnProperty(key)) console.warn('%c' + key + '%c is ignored in Variant class', 'color: blue', 'color: inherit');
      });
    }
  }, {
    key: "mergeJson",
    value: function mergeJson(json) {
      this.value = json.value;
      this.valuedes = json.valuedes;
      this.visible = json.visible;
      this.fd = json.fd;
      this.agg = json.agg;
      this.div = json.div;
      this.layer = json.layer;
      this.img = json.img;
      this.imgColor = json.imgColor;
      this.data = json.data;
      this.obbligate = json.obbligate;
    }
  }, {
    key: "setRowValue",
    value: function setRowValue(newVal) {
      var correctValue = newVal;
      if (this.cle) {
        var limits = this.cle;
        if (limits) {
          correctValue = (0, _parseFloat2["default"])(newVal);
          if (isNaN(correctValue)) correctValue = 0;
          if (correctValue < limits.min) correctValue = limits.min;
          if (correctValue > limits.max && limits.max > 0 && limits.max >= limits.min) correctValue = limits.max;
          if (limits.step > 0) {
            correctValue = Math.floor((correctValue - limits.min) / limits.step + .5) * limits.step + limits.min;
          }
        }
      }
      this.value = correctValue + '';
    }
  }]);
  return Variant;
}();
exports.Variant = Variant;
//# sourceMappingURL=Variant.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/Variant.js
// module id = 477
// module chunks = 142